import clsx from 'clsx';
import React from 'react';

interface RecordingIndicatorProps {
  className?: string;
}

function RecordingIndicator({ className = '' }: RecordingIndicatorProps) {
  return (
    <div className={clsx('flex items-center gap-0.5', className)}>
      <div className="recording-bar" />
      <div className="recording-bar" />
      <div className="recording-bar" />
    </div>
  );
}

export default RecordingIndicator;
